import { render } from "./result-tags.vue?vue&type=template&id=6201722d"
import script from "./result-tags.vue?vue&type=script&lang=js"
export * from "./result-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__